const selectionTypes = {
  all: 'all',
  page: 'page',
  multi: 'multi',
  single: 'single'
};

export default selectionTypes;
